var React = require('react');

function Strava (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Strava icon"),React.createElement("path",{"d":"M15.387 17.944l-2.089-4.116h-3.065L15.387 24l5.15-10.172h-3.066m-7.008-5.599l2.836 5.598h4.172L10.463 0l-7 13.828h4.169","key":1})]);
}

Strava.defaultProps = {"width":"24px","height":"24px","viewBox":"0 0 24 24","role":"img"};

module.exports = Strava;

Strava.default = Strava;



// WEBPACK FOOTER //
// ./src/images/icons/strava.svg